<template>
  <div class="table-wrapper">
    <TreeTable
      :value="data.children"
      showGridlines
    >
      <Column
        field="Moment"
        header="Дата"
        expander
      ></Column>
      <Column
        field="Time"
        header="Время"
      >
        <template #body="{ node }">
          <div class="table-wrapper__cell-time" v-if="node.data.Time">
            <span>{{ node.data.Time }}</span>
              <i
                class="pi pi-eye"
                @click="goToVersionView(node.data.RecordId)"
              />
          </div>
        </template>
      </Column>
      <Column field="Changes" header="Изменения"></Column>
    </TreeTable>
  </div>
</template>

<script>
import router from '@/router'

import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'

export default {
  name: 'StoryChangeUser',
  components: {
    TreeTable,
    Column
  },
  props: {
    data: {
      type: Array,
      default: () => ([])
    }
  },
  setup () {
    const goToVersionView = (val) => {
      router.push(`/roles/version/${val}`)
    }

    return {
      goToVersionView
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  width: 70vw;
  height: 70vh;
  overflow: auto;
  font-weight: 500;
  border: 1px solid #e9ecef;

  &__cell-time {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 5px;
  }
}

:deep(.pi) {
  position: absolute;
  right: 0;
  padding: 4px;
  box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.30);
  border-radius: 4px;
  cursor: pointer;
}

:deep(.p-treetable .p-treetable-tbody > tr > td ) {
  padding: 10px;
}

:deep(thead) {
  font-size: 18px;
}

:deep(tr) {
  font-weight: 500;
}

::-webkit-scrollbar {
  width: 9px;
  height: 100px;
}
::-webkit-scrollbar-track {
  background: #FFFFFF;
  border-width: 1px 1px 1px 0px;
  border-style: solid;
  border-color: #BCBCBC;
}
::-webkit-scrollbar-thumb {
  background-color: #1BA6DA;
  border-radius: 5px;
  height: 100px;
}
::-webkit-scrollbar-button:single-button {
  border: 10px solid #FFFFFF;
  border-bottom: 20px solid #1BA6DA;
}
::-webkit-scrollbar-button:end {
  border: 10px solid #FFFFFF;
  border-top: 20px solid #1BA6DA;
}
</style>
